
export function isEdge() {
	return /Edge/.test(navigator.userAgent);
}